export type FormState = 'initial' | 'sending' | 'success' | 'failure';
export type FormType = 'general' | 'health' | 'cinema' | 'initial';
export type FormData = {
  title: string;
  contentWrapperColor: string;
  btnInputColor: string;
  textColor: string;
  inputBorderActiveColor: string;
};
export const PLACEHOLDER = 'Введите почту';
export const SUBMIT_BUTTON_TEXT = 'Подписаться';

export const successFeedback = {
  title: 'Вы почти у цели!',
  subtitle:
    'Мы отправили вам письмо: нажмите на кнопку внутри него, чтобы подтвердить подписку на рассылку.',
};

export const failureFeedback = {
  title: 'Что-то пошло не так.',
  subtitle: 'Не удалось отправить вам письмо. Попробуйте подписаться ещё раз.',
};

export const FORM_DATA: Record<FormType, FormData> = {
  general: {
    title: '«Дайджест»: только лучшие статьи&nbsp—&nbspв вашем ящике',
    contentWrapperColor: '#F3F5FC',
    btnInputColor: '#2962F9',
    textColor: '#000000',
    inputBorderActiveColor: '#2962F9',
  },
  health: {
    title: '«Йод»: проверенные факты для всех, кто хочет быть здоров',
    contentWrapperColor: '#FCEFF2',
    btnInputColor: '#B9356F',
    textColor: '#B9356F',
    inputBorderActiveColor: '#B9356F',
  },
  cinema: {
    title: '«Смотритель»: самое интересное из мира кино и сериалов',
    contentWrapperColor: '#EEEAF9',
    btnInputColor: '#6129C4',
    textColor: '#6129C4',
    inputBorderActiveColor: '#6129C4',
  },
  initial: {
    title: '«Инициал»: бесплатный курс для начинающих авторов',
    contentWrapperColor: '#FFF8EA',
    btnInputColor: '#ED5E42',
    textColor: '#000000',
    inputBorderActiveColor: '#000000',
  },
};
